// ═══════════════════════════════════════════════════════════════════════════════
// Settlement help popover — steps & notes (? trigger via shared HelpPopover)
// ═══════════════════════════════════════════════════════════════════════════════

import { useLanguage } from '../../contexts/LanguageContext';
import { HelpPopover } from '../ui/HelpPopover';

export const SettlementHelpPopover = () => {
  const { t } = useLanguage();

  return (
    <HelpPopover
      triggerAriaLabel={t('settlement.helpPopoverTriggerAria')}
      panelAriaLabel={t('settlement.helpPopoverAria')}
      estimatedPanelHeightPx={280}
    >
      <p className="text-sm font-bold text-gray-900 dark:text-gray-100">
        {t('settlement.helpPopoverTitle')}
      </p>
      <ol className="mt-2 list-decimal space-y-1.5 pl-4 text-xs leading-relaxed text-gray-700 dark:text-gray-200">
        <li>{t('settlement.helpPopoverStep1')}</li>
        <li>{t('settlement.helpPopoverStep2')}</li>
        <li>{t('settlement.helpPopoverStep3')}</li>
      </ol>
      <p className="mt-3 text-xs font-semibold text-gray-800 dark:text-gray-100">
        {t('settlement.helpPopoverNotesHeading')}
      </p>
      <ul className="mt-1 list-disc space-y-1.5 pl-4 text-xs leading-relaxed text-gray-600 dark:text-gray-300">
        <li>{t('settlement.helpPopoverNote1')}</li>
        <li>{t('settlement.helpPopoverNote2')}</li>
      </ul>
    </HelpPopover>
  );
};
